import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-331fe2be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "NewColumnsController",
  ref: "elementref"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_checkbox = _resolveComponent("new-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsParent, (column, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `column-${idx}`,
        class: "mt-2"
      }, [
        _createVNode(_component_new_checkbox, {
          class: "checkbox--blue checkbox--light",
          value: _ctx.isColumnChecked(column.key),
          label: column.name,
          onClick: ($event: any) => (_ctx.toggleColumn(column))
        }, null, 8, ["value", "label", "onClick"])
      ]))
    }), 128)),
    _createVNode(_component_new_checkbox, {
      class: "border-t mt-5 pt-3 checkbox--blue checkbox--light NewColumnsController__item",
      value: _ctx.allColumnsChecked,
      label: "Все колонки",
      onClick: _ctx.toggleAllColumns
    }, null, 8, ["value", "onClick"])
  ], 512))
}